export default __webpack_public_path__ + "static/media/TnB0481.a9ffcd1c.jpg";